import PropTypes from "prop-types";
import { Toast as BSToast, ToastContainer } from "react-bootstrap";

export const Toast = ({
  body,
  delay = 3000,
  show = true,
  onClose,
  position = "top-end",
  type = "info",
  header = "",
}) => {
  const getHeaderText = () => {
    if (header) {
      return header;
    } else if (type === "error") {
      return "Error";
    }
    return "Notification";
  };

  return (
    body && (
      <ToastContainer position={position} className="toast-container-v2">
        <BSToast show={show} onClose={onClose} delay={delay} autohide>
          <BSToast.Header className={`${type} toast-main-header-v2`}>
            <strong className="me-auto toast-header-v2">
              {getHeaderText()}
            </strong>
          </BSToast.Header>
          <BSToast.Body className="toast-body-v2">{body}</BSToast.Body>
        </BSToast>
      </ToastContainer>
    )
  );
};

Toast.propTypes = {
  body: PropTypes.any,
  delay: PropTypes.number,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  position: PropTypes.string,
  type: PropTypes.oneOf(["info", "error"]),
  header: PropTypes.string,
};
